<template>

	<section class="full-width no-padding-top" id="profile-update">

		<div class="container">

			<div class="row">

				<div class="col-12">
					<h2>Saved data</h2>
					<p>Here you can manage any locally stored data</p>
				</div>

			</div>

			<div class="row">

				<div class="col-12">

                    <p><button class="core-btn" v-bind:disabled="thinking" @click="clear_planner()">Clear planner data</button></p>
					<p>This will clear the automatically generated planner data - this will regenerate on your next visit to the planner</p>
					<br><br>
                    <p><button class="core-btn" v-bind:disabled="thinking" @click="clear_caches()">Clear caches</button></p>
					<p>This will clear all caches, this can be useful if you're experiencing bugs</p>

				</div>


			</div>

		</div>

	</section>

</template>

<script>
	module.exports = {

		name: 'saved-data',

		data() {

			return {

				thinking: false,

				profile: {

				}

			}

		},

		methods: {

            clear_planner() {

				this.thinking = true;

				window.coreHelpers.ajax.call(this, 'GET', 'lc_planner_clear_data', false, function(res) {

					this.thinking = false;
					window.vueMessages.addMessage('Your planner data has been cleared');

				}, function(res) {

					this.thinking = false;

				});

            },

            clear_caches() {

				this.thinking = true;

				localStorage.clear();

				window.coreHelpers.ajax.call(this, 'GET', 'lc_clear_caches', false, function(res) {

					this.thinking = false;
					window.vueMessages.addMessage('Caches cleared');

				}, function(res) {

					this.thinking = false;

				});

            }

		}
	}
</script>